import React, { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { Box, Container, Typography } from "@mui/material";
import { useLocation } from "react-router-dom";
import moment from "moment";
import { COLORS } from "../../constants";
import MobileSiteFooter from "./MobileSiteFooter";
import DesktopSiteFooter from "./DesktopSiteFooter";
import InstagramIcon from "@mui/icons-material/Instagram";
import XIcon from "@mui/icons-material/X";
import FacebookIcon from "@mui/icons-material/Facebook";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import "./style.css";
import useSystemHook from "./../../hooks/SystemHook";

const SiteFooter = () => {
  const [currentPage, setCurrentPage] = useState(null);
  const location = useLocation();

  const { isMobile, isTablet, isDesktop } = useSystemHook();

  useEffect(() => {
    const pathName = location.pathname;
    const pageName = pathName.split("/").pop();
    setCurrentPage(pageName);
  }, [location]);
  useEffect(() => {
    const pathName = location.pathname;
    const pageName = pathName.split("/").pop();
    setCurrentPage(pageName);
  }, [location]);

  const goToTop = () => {
    document.querySelector("body").scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const contactInfo = {
    address: "28 Great N Rd, \nBrentwood Park, Benoni, \n1500",
    phone: "+27 11 747 5200\nMon-Thur 08:00 - 16:30\nFri 08:00 - 14:00",
    email: "info@argusmotoring.co.za",
  };

  const socialLinks = [
    {
      href: "https://www.instagram.com/argusmotoring",
      icon: <InstagramIcon sx={{ fontSize: "1.5rem" }} />,
    },
    { href: "#", icon: <XIcon sx={{ fontSize: "1.5rem" }} /> },
    {
      href: "https://www.facebook.com/argusmotoring",
      icon: <FacebookIcon sx={{ fontSize: "1.5rem" }} />,
    },
    {
      href: "https://wa.me/+27836545120",
      icon: <WhatsAppIcon sx={{ fontSize: "1.5rem" }} />,
    },
  ];

  const sections = [
    {
      title: "My Account",
      links: [
        { href: "#", label: "My Account" },
        { href: "#", label: "Orders" },
        { href: "/cart", label: "Shopping Cart" },
        { href: "#", label: "Weekly Deals" },
      ],
    },
    {
      title: "Customer Service",
      links: [
        { href: "/contact-us", label: "Contact Us" },
        { href: "/popia", label: "POPIA Act" },
        { href: "/privacy-statement", label: "Privacy Policy" },
        { href: "/terms-of-service", label: "Terms & Conditions" },
        { href: "/faq", label: "Help" },
      ],
    },
    {
      title: "Company",
      links: [
        { href: "/about", label: "About Us" },
        { href: "/team", label: "Team" },
        { href: "/tradeshow", label: "Trade Shows" },
        { href: "/merchandising", label: "Merchandising" },
      ],
    },
  ];

  return (
    <Box
      className={isMobile ? "argus-footer-mobile" : "argus-footer"}
      sx={{ color: COLORS.white, mt: 10 }}
    >
      <Container disableGutters>
        {isMobile || isTablet ? (
          <MobileSiteFooter
            contactInfo={contactInfo}
            socialLinks={socialLinks}
            sections={sections}
          />
        ) : (
          <DesktopSiteFooter
            contactInfo={contactInfo}
            socialLinks={socialLinks}
            sections={sections}
          />
        )}
      </Container>

      {/* Copyright Notice (Desktop and Mobile) */}
      <Box
        sx={{
          textAlign: "center",
          paddingTop: "1rem",
          borderTop: `1px solid ${COLORS.darkText}`,
          marginTop: "1rem",
          width: "100%",
          p: 2,
        }}
      >
        <Typography
          variant="caption"
          sx={{
            textAlign: "center",
            paddingTop: "1rem",
            fontWeight: "100",
            fontSize: "var(--font-size-xxs)",
            color: COLORS.lightGray,
          }}
        >
          {`©Copyright ${moment().year()} by Argus Motor Company. All Rights Reserved.`}
        </Typography>
      </Box>
    </Box>
  );
};

export default SiteFooter;
